module.exports = __webpack_public_path__ + "img/avatar-14.dbb990aa.png";